import { render, staticRenderFns } from "./WebRtcLivestreamCreate.vue?vue&type=template&id=7fa8f7f4&scoped=true"
import script from "./WebRtcLivestreamCreate.vue?vue&type=script&lang=js"
export * from "./WebRtcLivestreamCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa8f7f4",
  null
  
)

export default component.exports